// utils/permissionsShared.ts
import { Permissions } from 'ts-interfaces';

// Shared cache for storing permissions data
export const permissionsCache = new Map<string, Permissions>();

// Track active listeners to avoid duplicates
export const activeListeners = new Map<string, number>();

// Utility to manage listener reference counting
export const incrementListenerCount = (uid: string): number => {
    const currentCount = activeListeners.get(uid) || 0;
    const newCount = currentCount + 1;
    activeListeners.set(uid, newCount);
    return newCount;
};

export const decrementListenerCount = (uid: string): number => {
    const currentCount = activeListeners.get(uid) || 0;
    const newCount = Math.max(0, currentCount - 1);
    
    if (newCount === 0) {
        activeListeners.delete(uid);
    } else {
        activeListeners.set(uid, newCount);
    }
    
    return newCount;
};

// Utility to check if we should set up a new listener
export const shouldSetupNewListener = (uid: string): boolean => {
    // If there are no active listeners for this uid, we should set up a new one
    return !activeListeners.has(uid) || activeListeners.get(uid) === 0;
};

// Utility to clear all caches (useful for logout or testing)
export const clearAllPermissionsCaches = () => {
    permissionsCache.clear();
    activeListeners.clear();
};